/* qeslint-disable */
// q@ts-nocheck

const DEFAULT_TIME_SCALE = 60;

// Dimensions
export const LayoutParameters = {
    LINE_HEIGHT: 26,
    DIAMOND_SIZE: 10,
    MARKER_TRACK_HEIGHT: 60,
    width: 1000,
    height: 150,
    time_scale: DEFAULT_TIME_SCALE, // number of pixels to 1 second
    DEFAULT_FRAME_LENGTH: 15, // seconds
    DEFAULT_TIME_SCALE: DEFAULT_TIME_SCALE,
    UI_NUMBER_WIDTH: 55,
    STATUS_BAR_HEIGHT: 22,
    LEFT_GUTTER: 20,
    RIGHT_GUTTER: 20
};
